import _jsx from "@babel/runtime/helpers/jsx";
var _Glyphicon;
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import _get from 'lodash/get';
import { useDevice } from '@atc/react-device';
import Glyphicon from '../Glyphicon/index.js';
import OverlayTrigger from '../OverlayTrigger/index.js';
import Popover from '../Popover/index.js';

/**
 *  An info type icon (with optional text) that takes infoText (string).
 *  infoText is displayed in a tooltip when the icon
 *  is clicked.
 */

const InfoIcon = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    infoText,
    textAfterIcon = '',
    textColor = 'text-blue',
    popoverId = 'info-icon',
    className,
    trigger,
    onCloseClick,
    onClick,
    ...rest
  } = props;
  const device = useDevice();
  const isXs = _get(device, 'is.xs', false);
  const isLg = _get(device, 'is.lg', true);
  const triggerType = isLg ? ['hover', 'focus', 'click'] : ['click'];
  return /*#__PURE__*/React.createElement(OverlayTrigger, Object.assign({
    trigger: trigger || triggerType,
    rootClose: true,
    ref: ref,
    onClick: onClick,
    overlay: /*#__PURE__*/React.createElement(Popover, Object.assign({
      id: popoverId,
      onClick: onClick
    }, isXs && {
      onCloseClick
    }), infoText)
  }, rest), /*#__PURE__*/_jsx("span", {
    className: clsx(textColor, className)
  }, void 0, _Glyphicon || (_Glyphicon = /*#__PURE__*/_jsx(Glyphicon, {
    "aria-label": "more info",
    glyph: "info",
    role: "button",
    tabIndex: "0"
  })), ' ', textAfterIcon));
});
export default InfoIcon;